import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToHashElement from './components/ScrollToHashElement';
import Layout from './components/Layout';
import Home from './pages/Home/Home';
import ThaisaViana from './pages/NossosProfissionais/PerfisIndividuais/ThaisaViana';
import LuisaViana from './pages/NossosProfissionais/PerfisIndividuais/LuisaViana';
import MarliMiranda from './pages/NossosProfissionais/PerfisIndividuais/MarliMiranda';
import MarisaMathes from './pages/NossosProfissionais/PerfisIndividuais/MarisaMathes';

function App() {
  return (
    <Router>
      <ScrollToHashElement /> {/* Faz o scroll suave funcionar */}
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/profissionais/thaisaviana" element={<ThaisaViana />} />
          <Route path="/profissionais/luisaviana" element={<LuisaViana />} />
          <Route path="/profissionais/marlimiranda" element={<MarliMiranda />} />
          <Route path="/profissionais/marisamathes" element={<MarisaMathes />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
